var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUngroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_919_33473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_919_33473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16299 11.8292L5.17132 10.8375L8.21715 7.79167H5.66715V6.375H10.6255V11.3333H9.20882V8.78333L6.16299 11.8292ZM13.4588 8.5V3.54167H8.50049V2.125H14.8755V8.5H13.4588ZM3.54215 14.875C3.15257 14.875 2.81906 14.7363 2.54163 14.4589C2.2642 14.1814 2.12549 13.8479 2.12549 13.4583V2.125H3.54215V13.4583H14.8755V14.875H3.54215Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroup);
export default __webpack_public_path__ + "static/media/ungroup.bbb07b036d4f1409d4420ad4bd30454d.svg";
export { ForwardRef as ReactComponent };